import styled from "styled-components";
import { Image as AntImage, Row as AntRow, Col as AntCol } from "antd";
import { SportDefaultIMG, FriendListBg, IMG_BG_SPORTS } from "@assets";

export const RootContainer = styled.div`
  position: relative;
`;

export const Row = styled(AntRow)`
  margin-top: 35px;
  background: #e1f0ff;
  border-radius: 12px;
  padding: 32px 16px 16px 16px;
`;

export const Col = styled(AntCol)`
  width: 33%;
  text-align: center;
  margin-bottom: 8px;
`;

export const SubContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: SportDefaultIMG,
  preview: false,
})`
  width: 84px !important;
  border-radius: 50%;
  object-fit: contain;
  aspect-ratio: 1;
  cursor: pointer;
  background-image: url(${IMG_BG_SPORTS});
  background-repeat: no-repeat;
  background-size: cover;

  @media screen and (max-width: 353px) {
    width: 74px !important;
  }
  @media screen and (max-width: 343px) {
    width: 64px !important;
  }
`;

export const Label = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  padding-top: 5px;
`;

export const TitleWrapper = styled.div`
  background-image: url(${FriendListBg});
  background-repeat: no-repeat;
  background-position: center; /* Center the background image horizontally and vertically */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  position: absolute;
  top: -16px;
`;

export const Title = styled.div`
  text-align: center;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-left: 5px;
  padding-right: 5px;
`;
